module.exports = __webpack_public_path__ + "img/ref-naturel-2.74d42b2.png";